<div class="d-flex justify-content-between">
  <app-breadcrumb [hidden]="this.auService.auditPageFrom!='Main'" id="MainActivity"></app-breadcrumb>
</div>

<mat-tab-group
  [hidden]="((this.auService.auditPageFrom!='Main') && selectedAuditGroup.length > 0 || !showgrid) ||  qmsService.showmodulegrid==false"
  mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
  (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex" #tabsGroup>
  <mat-tab *ngFor="let tab of auTabPanel" label="{{tab.Name}}">
    <ng-template mat-tab-label>
      <span>
        <i *ngIf="tab.Name == 'Annual Audit Schedule'" class='fa fa-calendar' style="font-size: 18px;"
          aria-hidden="true"></i>
        <i *ngIf="tab.Name == 'Audit Plan'" class='fa fa-tasks' style="font-size: 18px;" aria-hidden="true"></i>
        <i *ngIf="tab.Name == 'Conduct Audit'" class='fa-solid fa-bars-progress' style="font-size: 18px;"
          aria-hidden="true"></i>
      </span>&nbsp;<span>{{tab.Name}}</span>
    </ng-template>
    <div class="d-flex justify-content-between mt-3 mb-2">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
          <button class="btn menu_item border border-secondary-subtle outline-0 dropdown-toggle" type="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            Export
            <i class="fa-solid fa-chevron-down ms-5"></i>
          </button>
          <ul class="dropdown-menu px-3 border-0">
            <li class="d-flex align-items-center" (click)="openReportPopup('Excel')"
              (keydown.enter)="openReportPopup('Excel')">
              <div>
                <i class="fa fa-file-excel-o"></i>
              </div>
              <span class="dropdown-item px-2 dropdown_text">Export to Excel
              </span>
            </li>
            <li class="d-flex align-items-center" (click)="openReportPopup('Pdf')"
              (keydown.enter)="openReportPopup('Pdf')">
              <div>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <span class="dropdown-item px-2 dropdown_text">Export to PDF
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>

        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="selectedAuditGroup.length>0 && ((selectedTab =='Annual Audit Schedule'&& addScheduler)||(selectedTab =='Audit Plan'&& addplanner))"
          (click)="openAddPopup(tab.Name, false)" (keydown.enter)="openAddPopup(tab.Name, false)">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
    <div class="d-flex detail-menu-container">
      <div id="{{ listOfChartCountsDetails.id }}" class="mini-chart-container" *ngFor="
            let listOfChartCountsDetails of getListOfGridChartCountsDetails;
            let ix = index"
        [ngStyle]="{'boxShadow': ((hightSection==listOfChartCountsDetails.status)?'rgb(38 102 255) 0px 5px 10px':'')}">

        <div class="d-flex gap-1" (click)="onClickOnChart($event, listOfChartCountsDetails)"
          (keydown.enter)="onClickOnChart($event, listOfChartCountsDetails)"
          *ngIf="listOfChartCountsDetails.status != 'My Overdue' && listOfChartCountsDetails.status != 'My Active' && listOfChartCountsDetails.status != 'My Total' && listOfChartCountsDetails.status != 'Others' && listOfChartCountsDetails.status != 'Overdue'">
          <div>
            <div class="d-flex justify-content-center align-items-center requests_menu"
              *ngIf="listOfChartCountsDetails.status == 'Total'">
              <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                alt="total requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu closed_request"
              *ngIf="listOfChartCountsDetails.status == 'Closed'">
              <img src="../../../assets/img/cr_module/closed_requests.svg" width="16px" height="16px"
                alt="closed requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu active_request"
              *ngIf="listOfChartCountsDetails.status == 'Active'">
              <img src="../../../assets/img/cr_module/active_requests.svg" width="16px" height="16px"
                alt="active requests" />
            </div>
          </div>
          <div class="d-flex flex-column">
            <span class="chart-count">
              {{ listOfChartCountsDetails.count }}
            </span>
            <span class="d-flex px-1">
              <span class="chart-text me-2"
                *ngIf="listOfChartCountsDetails.status == 'Closed' && tab.Name == 'Annual Audit Schedule'">
                Scheduled
              </span>
              <span class="chart-text me-2"
                *ngIf="!(listOfChartCountsDetails.status == 'Closed' && tab.Name == 'Annual Audit Schedule')">
                {{ listOfChartCountsDetails.status }}
              </span>
              <span class="percentage-count">{{
                listOfChartCountsDetails.status == "Total"
                ? 100
                : listOfChartCountsDetails.percentage
                }}%</span>
            </span>
            <span class="progress-bar-container"
              [ngStyle]="{'background': listOfChartCountsDetails.colorCode, 'width': listOfChartCountsDetails.percentage + '%'}">
            </span>
          </div>
        </div>
        <div class="d-flex gap-1" (click)="onClickOnChart($event, listOfChartCountsDetails)"
          (keydown.enter)="onClickOnChart($event, listOfChartCountsDetails)" *ngIf="showAllTask">
          <div *ngIf="listOfChartCountsDetails.status == 'Others' || listOfChartCountsDetails.status == 'Overdue'">
            <div class="d-flex justify-content-center align-items-center requests_menu other_request"
              *ngIf="listOfChartCountsDetails.status == 'Others'">
              <img src="../../../assets/img/cr_module/other_requests.svg" width="16px" height="16px"
                alt="other requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu overdue_request"
              *ngIf="listOfChartCountsDetails.status == 'Overdue'">
              <img src="../../../assets/img/cr_module/overdue_request.svg" width="16px" height="16px"
                alt="overdue requests" />
            </div>
          </div>
          <div class="d-flex flex-column"
            *ngIf="listOfChartCountsDetails.status == 'Others' || listOfChartCountsDetails.status == 'Overdue'">
            <span class="chart-count">
              {{ listOfChartCountsDetails.count }}
            </span>
            <span class="d-flex px-1">
              <span class="chart-text me-2"
                *ngIf="listOfChartCountsDetails.status == 'Closed' && tab.Name == 'Annual Audit Schedule'">
                Scheduled
              </span>
              <span class="chart-text me-2"
                *ngIf="!(listOfChartCountsDetails.status == 'Closed' && tab.Name == 'Annual Audit Schedule')">
                {{ listOfChartCountsDetails.status }}
              </span>
              <span class="percentage-count">{{
                listOfChartCountsDetails.status == "Total"
                ? 100
                : listOfChartCountsDetails.percentage
                }}%</span>
            </span>
            <span class="progress-bar-container"
              [ngStyle]="{'background': listOfChartCountsDetails.colorCode, 'width': listOfChartCountsDetails.percentage + '%'}">
            </span>
          </div>
        </div>
        <div class="d-flex gap-1" (click)="onClickOnChart($event, listOfChartCountsDetails)"
          (keydown.enter)="onClickOnChart($event, listOfChartCountsDetails)" *ngIf="showMyTask">
          <div
            *ngIf="listOfChartCountsDetails.status == 'My Overdue' || listOfChartCountsDetails.status == 'My Active' || listOfChartCountsDetails.status == 'My Total'">

            <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
              *ngIf="listOfChartCountsDetails.status == 'My Total'">
              <img src="../../../assets/img/cr_module/my_total.svg" width="16px" height="16px"
                alt="my total requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
              *ngIf="listOfChartCountsDetails.status == 'My Active'">
              <img src="../../../assets/img/cr_module/my_active.svg" width="16px" height="16px"
                alt="my total requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
              *ngIf="listOfChartCountsDetails.status == 'My Overdue'">
              <img src="../../../assets/img/cr_module/overdue_request.svg" width="16px" height="16px"
                alt="my overdue" />
            </div>
          </div>
          <div class="d-flex flex-column"
            *ngIf="listOfChartCountsDetails.status == 'My Overdue' || listOfChartCountsDetails.status == 'My Active' || listOfChartCountsDetails.status == 'My Total'">
            <span class="chart-count">
              {{ listOfChartCountsDetails.count }}
            </span>
            <span class="d-flex px-1">
              <span class="chart-text me-2"
                *ngIf="listOfChartCountsDetails.status == 'Closed' && tab.Name == 'Annual Audit Schedule'">
                Scheduled
              </span>
              <span class="chart-text me-2"
                *ngIf="!(listOfChartCountsDetails.status == 'Closed' && tab.Name == 'Annual Audit Schedule')">
                {{ listOfChartCountsDetails.status }}
              </span>
              <span class="percentage-count">{{
                listOfChartCountsDetails.status == "Total"
                ? 100
                : listOfChartCountsDetails.percentage
                }}%</span>
            </span>
            <span class="progress-bar-container"
              [ngStyle]="{'background': listOfChartCountsDetails.colorCode, 'width': listOfChartCountsDetails.percentage + '%'}">
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex float-right" style="border-left: 1px solid #cfcfcf;" *ngIf="showMyFilter">
        <button class="justify-content-left align-items-center btn menu_item active border-0 outline-0 dropdown-toggle"
          type="button" style="height:40px;font-size: 12px;" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa fa-filter" width="24px" height="24px" aria-hidden="true" style="color:#005c8a"></i>
          {{choosedFilter.filterName}}
          <i *ngIf="choosedFilter.filterName" class="fa-solid fa-chevron-down"></i>
        </button>
        <ul class="dropdown-menu px-3 border-0 dropdown_items">
          <li class="d-flex align-items-center pt-2">
            <a class="dropdown-item px-3 dropdown_text" style="font-size: 12px;" (click)="filterMethodClicked(null)"
              style="border: 1px solid #cfcfcf;">
              <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px" alt="filter">&nbsp;None</a>
          </li>
          <li *ngFor="let item of filterList" class="d-flex align-items-center pt-2" style="border: 1px solid #cfcfcf;">
            <a class="dropdown-item px-3 dropdown_text" style="font-size: 12px;" (click)="filterMethodClicked(item)">
              <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px"
                alt="filter">&nbsp;{{item.filterName}}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="table-container">
      <table class="dynamic-table-container" aria-describedby="table-description">
        <thead>
          <th [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''"></th>
          <th class="grid-header-container" *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
            let ix = index" (focus)="focusEmpty()"
            [ngStyle]="{'min-width':oneQmsUsersDataForTable1Data.width != null? oneQmsUsersDataForTable1Data.width: '200px'}"
            class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <!-- search input row is added -->
          <tr>
            <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col' : ''"></td>
            <td (focus)="focusEmpty()" *ngFor=" let oneQmsUsersDataForTable1Data of
                            columnLists.fieldColumnarray; let ix=index " [ngStyle]=" { 'min-width' :
                            oneQmsUsersDataForTable1Data.width !=null ? oneQmsUsersDataForTable1Data.width : '200px' }"
              class="sticky-dynamic-row1" (mouseover)="cssfunction(0)">
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
              </div>
            </td>
          </tr>
          <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
            <td style="min-width: 60px; text-align: center;background-color: white;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
              <div style="display: flex;">
                <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div>
                  <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                    (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                </div>
              </div>
            </td>
            <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
              (focus)="focusEmpty()" class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width !=null ? key.width[i] :'200px','max-width': key.width !=null ? key.width[i] :'200px','overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" (click)="detailsData(list,i)" (mouseover)="cssfunction(i)"
              (keydown.enter)="detailsData(list,i)"
              [matTooltip]="list[key.columnsListarray] === 'htmlClobView' ? '' : list[key.columnsListarray]">
              <span *ngIf="key.dataType=='CHECKBOX'">
                <div class="gridCheckBoxes">
                  <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                    height="20">
                  <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                    width="20" height="20">
                </div>
              </span>
              <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'" [ngStyle]="{'color':
                        ((key.columnsListarray=='STATUS'|| key.columnsListarray=='SCHEDULE_STATUS' ) && (list[key.columnsListarray].includes('Rejected')||list[key.columnsListarray].includes('Deleted')||list[key.columnsListarray].includes('Obsoleted')))?'red':
                        ((key.columnsListarray=='STATUS'|| key.columnsListarray=='SCHEDULE_STATUS' ) && (list[key.columnsListarray].includes('Open')||list[key.columnsListarray].includes('Draft')||list[key.columnsListarray].includes('Initiated')||list[key.columnsListarray].includes('Scheduled')))?'orange':
                        ((key.columnsListarray=='STATUS'|| key.columnsListarray=='SCHEDULE_STATUS' ) && (list[key.columnsListarray].includes('Closed')||list[key.columnsListarray].includes('Completed')||list[key.columnsListarray].includes('Approved')||list[key.columnsListarray]=='Scheduled'))?'green':
                         i==0?'blue':'#0f3659','zoom':(key.columnsListarray=='STATUS'|| key.columnsListarray=='SCHEDULE_STATUS' )?'1.1':'1',
                         background:
                  (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                  (list[key.columnsListarray].includes('Rejected') ||
                    list[key.columnsListarray].includes('Deleted') ||
                    list[key.columnsListarray].includes('Obsoleted'))
                    ? '##FF3A291A'
                    : (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                      (list[key.columnsListarray].includes('Open') ||
                        list[key.columnsListarray].includes('Draft') ||
                        list[key.columnsListarray].includes('Scheduled') ||
                        list[key.columnsListarray].includes('Initiated'))
                    ? '#FF89001A'
                    : (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                      (list[key.columnsListarray].includes('Closed') ||
                        list[key.columnsListarray].includes('Completed') ||
                        list[key.columnsListarray].includes('Approved'))
                    ? '#00E58F1A'
                    : (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                      (list[key.columnsListarray].includes('QA Accepted') ||
                        list[key.columnsListarray].includes(
                          'Owner Acknowledged'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Approval'
                        ) ||
                        list[key.columnsListarray].includes('In Progress') ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Review'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending QA Acceptance'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Obsolete Approval'
                        ))
                    ? '#005C8A1A'
                    : i == 0
                    ? ''
                    : '',
                         'border':
                  (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                  (list[key.columnsListarray].includes('Rejected') ||
                    list[key.columnsListarray].includes('Deleted') ||
                    list[key.columnsListarray].includes('Obsoleted'))
                    ? '0.75px solid #FF3A29'
                    : (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                      (list[key.columnsListarray].includes('Open') ||
                        list[key.columnsListarray].includes('Draft') ||
                        list[key.columnsListarray].includes('Scheduled') ||
                        list[key.columnsListarray].includes('Initiated'))
                    ? '0.75px solid #FF8900'
                    : (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                      (list[key.columnsListarray].includes('Closed') ||
                        list[key.columnsListarray].includes('Completed') ||
                        list[key.columnsListarray].includes('Approved'))
                    ? '0.75px solid #00E58F'
                    : (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') &&
                      (list[key.columnsListarray].includes('QA Accepted') ||
                        list[key.columnsListarray].includes(
                          'Owner Acknowledged'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Approval'
                        ) ||
                        list[key.columnsListarray].includes('In Progress') ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Review'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending QA Acceptance'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Obsolete Approval'
                        ))
                        ? '0.75px solid #005C8A1A'
                    :(key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS')
                    ?'0.75px solid #0f3659'
                    : i == 0
                    ? ''
                    : '',
                'font-family':
                  (key.columnsListarray == 'STATUS'||key.columnsListarray=='SCHEDULE_STATUS') ? 'Poppins' : '',
                'border-radius': '6px',
                padding: '3px 9px'}">
                <span *ngIf="list[key.columnsListarray]=='htmlClobView'
                                 ||key.columnsListarray=='AUDIT_PURPOSE'||key.columnsListarray=='AUDIT_SCOPE'
                                 ||key.columnsListarray=='AUDIT_REFERENCES'||key.columnsListarray=='REMARKS'">
                  <div class="download-button-continer btn-align" mat-dialog-actions>
                    <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                      (click)="getClobData(list,key.columnsListarray)">
                      <span class="ms-1">View</span>
                    </button>
                  </div>
                </span>
                <span
                  *ngIf="list[key.columnsListarray] != 'htmlClobView' &&
                                      key.columnsListarray != 'AUDIT_PURPOSE'&& key.columnsListarray!='AUDIT_SCOPE'
                                 &&key.columnsListarray!='AUDIT_REFERENCES'&& key.columnsListarray !='REMARKS'">{{list[key.columnsListarray]}}</span>
              </span>
              <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray]
                }}</span>
            </td>
            <td class="sticky-col first-col">
              <div class="action-icons">
                <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                  *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('individual',list)"
                  (keydown.enter)="openAuditTrail('individual',list)"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(5)">5</button>
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <div class="loader_block">
        <span class="loader_dots"></span>
        <span class="loader_dots"></span>
        <span class="loader_dots"></span>
      </div>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row" *ngIf="operationFlag == 'EDIT'">
        <div class="d-flex justify-content-between mt-1 mb-2">
          <div>
            <app-task-stage-statistics *ngIf=" qmsService.refereshBreadCrumb"></app-task-stage-statistics>
          </div>

          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center justify-content-center communication_cta pointer"
              (click)="openHeadReportPopup()" (keydown.enter)="openHeadReportPopup()" matTooltip="Report"
              *ngIf="selectedTab=='Audit Plan' || selectedTab=='Annual Audit Schedule'">
              <img src="../../../assets/img/cr_module/pdf.svg" width="11px" height="15px" alt="" />
            </div>

            <app-activity-dynamic-button></app-activity-dynamic-button>
          </div>

        </div>
        <div class="d-flex justify-content-end mt-1">
          <div class="d-flex gap-4 align-items-center">
            <div class="">
              <span class="crDetail-status1 status_text" *ngIf="auData != undefined">Status&nbsp;:&nbsp;
                <span *ngIf="selectedTab!='Annual Audit Schedule'">{{ this.auData.status }}</span>
                <span *ngIf="selectedTab=='Annual Audit Schedule'">{{ this.auData.scheduleStatus
                  }}</span>
              </span>
            </div>
            <div class="d-flex justify-content-end align-items-center gap-2">
            </div>
            <div class="d-flex gap-2">

            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3" *ngIf="auData.parentPlanAuditNo">
          <div><label for="email ">{{dynamicLabel['PARENT_PLAN_AU_ID'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['PARENT_PLAN_AU_ID']?.fieldNotes"
              [matTooltip]="dynamicLabel['PARENT_PLAN_AU_ID']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-12" style="position: relative;">
              <input id="au-id" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auData.parentPlanAuditId" [disabled]="true">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['ANNUAL_REF_NO'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['ANNUAL_REF_NO']?.fieldNotes"
              [matTooltip]="dynamicLabel['ANNUAL_REF_NO']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" *ngIf="!showAuRefNoAsTextBox" [(ngModel)]="selectedAuRefNo"
            (closed)="auRefNoTxt=''" (click)="focusSearch('auRefNoSearch')"
            (keydown.enter)="focusSearch('auRefNoSearch')"
            [ngClass]="{'odd-item-mat-select':isAuRefNoOdd==selectedAuRefNo}" [disabled]="isFrozen">
            <input type="search" id="auRefNoSearch" class="dropdownsearchstyle" [(ngModel)]="auRefNoTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auRefNoDropDown| assessmentSearch :auRefNoTxt" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <input class="input-filed-continers" *ngIf="showAuRefNoAsTextBox" type="text"
            [(ngModel)]="auData.annualRefNo">
        </div>
        <div class="col-md-3">
          <div>
            <label id="classification-validation" for="email">{{dynamicLabel['AUDIT_CLASSIFICATION'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_CLASSIFICATION']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_CLASSIFICATION']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuditClassification"
            (closed)="auditClassificationTxt=''" (click)="focusSearch('auditClassificationSearch')"
            (keydown.enter)="focusSearch('auditClassificationSearch')"
            [ngClass]="{'odd-item-mat-select':isAuditClassificationOdd==selectedAuditClassification}"
            [disabled]="isFrozen">
            <input type="search" id="auditClassificationSearch" class="dropdownsearchstyle"
              [(ngModel)]="auditClassificationTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auditClassificationDropDown| assessmentSearch :auditClassificationTxt"
              (onSelectionChange)="onClassificationSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="dropDownForAuMaster.length > 0">
          <div>
            <label for="email">Audit Master</label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuMaster" (closed)="auMasterTxt=''"
            (click)="focusSearch('auMasterSearch')" (keydown.enter)="focusSearch('auMasterSearch')"
            [ngClass]="{'odd-item-mat-select':isAuMasterOdd==selectedAuMaster}" [disabled]="isFrozen">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="auMasterTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onAuMasterSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of auMasterDropDown| assessmentSearch :auMasterTxt"
              (onSelectionChange)="onAuMasterSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3">
          <div>
            <label id="category-validation" for="">{{dynamicLabel['AUDIT_CATEGORY'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_CATEGORY']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_CATEGORY']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuditCategory" (closed)="auditCategoryTxt=''"
            (click)="focusSearch('auditCategorySearch')" (keydown.enter)="focusSearch('auditCategorySearch')"
            [ngClass]="{'odd-item-mat-select':isAuditCategoryOdd==selectedAuditCategory}"
            [disabled]="isFrozen || selectedAuMaster"><input type="search" id="auditCategorySearch"
              class="dropdownsearchstyle" [(ngModel)]="auditCategoryTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auditCategoryDropDown| assessmentSearch :auditCategoryTxt"
              (onSelectionChange)="onAuditCategorySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3">
          <div>
            <label id="type-validation" for="email">{{dynamicLabel['AUDIT_TYPE'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_TYPE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_TYPE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuditType" (closed)="auditTypeTxt=''"
            (click)="focusSearch('auMasterSearch')" (keydown.enter)="focusSearch('auMasterSearch')"
            [disabled]="isFrozen && freezeAuditTypeDropDown"
            [ngClass]="{'odd-item-mat-select':isAuditTypeOdd==selectedAuditType}">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="auditTypeTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onAuditTypeSelect($event,null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auditTypeDropDown| assessmentSearch :auditTypeTxt"
              (onSelectionChange)="onAuditTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="displayVendor">
          <div>
            <label id="vendor-validation" for="email">{{dynamicLabel['VENDOR_NAME'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['VENDOR_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['VENDOR_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input id="vendorName" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auData.vendorName" [disabled]="true">
            </div>
            <div class="col-sm-1"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
              (click)="openVendorPopup()" (keydown.enter)="openVendorPopup()" [ngClass]="{'disabled': isFrozen}">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3" *ngIf="displayDepartment">
          <div>
            <label id="department-validation" for="email">{{dynamicLabel['DEPT_NAME'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auData.departmentName" [disabled]="true">
            </div>
            <div class="col-sm-1"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
              (click)="openDepartmentPopup()" (keydown.enter)="openDepartmentPopup()"
              [ngClass]="{'disabled': isFrozen}">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3" [hidden]="!displayFunctionalAreaOrServices">
          <div>
            <label for="email">{{dynamicLabel['FUNCTIONAL_AREA_OR_SERVICES'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['FUNCTIONAL_AREA_OR_SERVICES']?.fieldNotes"
              [matTooltip]="dynamicLabel['FUNCTIONAL_AREA_OR_SERVICES']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select multiple matInput #functionalAreaOrServices placeholder="Select"
            [(ngModel)]="selectedFunctionalAreaOrServices" (closed)="functionalAreaOrServicesTxt=''"
            (click)="focusSearch('functionalAreaOrServicesSearch')"
            (keydown.enter)="focusSearch('functionalAreaOrServicesSearch')" [disabled]="isFrozen">
            <input type="search" id="functionalAreaOrServicesSearch" class="dropdownsearchstyle"
              [(ngModel)]="functionalAreaOrServicesTxt" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="functionalAreaOrServicesSelected" [indeterminate]="isIndeterminate"
                (change)="toggleAllSelection('functionalAreaOrServices', $event)">Select
                All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item of functionalAreaOrServicesDropDown| assessmentSearch :functionalAreaOrServicesTxt"
              (onSelectionChange)="onFunctionalAreaOrServicesSelect($event)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <ng-container *ngIf="dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y'">
          <div class="col-md-3">
            <div>
              <label id="requested-at" for="email">
                {{dynamicLabel['REQUESTED_AT']?.fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <mat-select matInput placeholder="Select" [(ngModel)]="auData.requestedAt"
              (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
              (keydown.enter)="focusSearch('focus-requested-at')"
              [ngClass]="{'odd-item-mat-select': isRequestedAtOdd == auData.requestedAt}">
              <input type="search" id="focus-requested-at" class="dropdownsearchstyle"
                [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" (onSelectionChange)="onRequestedAtSelect($event, null)"
                [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch :requestedAtSearchText"
                (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>

          <div class="col-md-6" *ngIf="auData.requestedAt">
            <div>
              <label id="business-area" for="email">
                {{auData.requestedAtName}}&nbsp;Area
              </label> <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput multiple placeholder="Select" #businessArea [(ngModel)]="selectedBusinessArea"
              *ngIf="businessAreaDropdown.length" (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
              (click)="focusSearch('focus-b-area')" (keydown.enter)="focusSearch('focus-b-area')">
              <input type="search" id="focus-b-area" class="dropdownsearchstyle" [(ngModel)]="businessAreaSearchText"
                matInput placeholder="search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected" (change)="toggleAllBusinessArea()">Select
                  All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
            <textarea type="text" class="input-filed-textarea" rows="4" cols="50" *ngIf="!businessAreaDropdown.length"
              [(ngModel)]="auData.coreBusinessAreaName" (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedTab == 'Annual Audit Schedule'">
          <ng-container *ngIf="!auData.scheduleAuditProposedDate">
            <div class="col-md-3">
              <div>
                <label id="proposed-or-schedule-validation" for="email">
                  {{dynamicLabel['AUDIT_PROPOSED_DATE'].fieldName}}
                  <span class="mandatory-symbol">*</span>
                </label>
              </div>
              <input type=" text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="auProposedDateConfig" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="auData.auditProposedDate"
                (ngModelChange)="onNgModelChange($event,'proposed-or-schedule-validation')" [disabled]="isFrozen">
            </div>
          </ng-container>
          <ng-container *ngIf="auData.scheduleAuditProposedDate">
            <div class="col-md-3">
              <div>
                <label for="email">
                  {{dynamicLabel['SCHEDULE_AUDIT_PROPOSED_DATE'].fieldName}}
                  <span class="mandatory-symbol">*</span>
                </label>
              </div>
              <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="commonDateConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.scheduleAuditProposedDate"
                [disabled]="true">
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="selectedTab == 'Audit Plan'">
          <div class="col-md-3">
            <div>
              <label id="proposed-or-schedule-validation" for="email">
                {{dynamicLabel['AUDIT_PROPOSED_DATE'].fieldName}}
                <span class="mandatory-symbol">*</span>
              </label>
            </div>
            <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="auProposedDateConfig"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.auditProposedDate"
              (ngModelChange)="onNgModelChange($event,'proposed-or-schedule-validation')" [disabled]="isFrozen">
          </div>
        </ng-container>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['SUB_GROUP_NAME'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['SUB_GROUP_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['SUB_GROUP_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" *ngIf="!showSubGroupAsTextBox" [(ngModel)]="selectedSubGroup"
            (closed)="SubGroupTxt=''" (click)="focusSearch('SubGroupSearch')"
            (keydown.enter)="focusSearch('SubGroupSearch')"
            [ngClass]="{'odd-item-mat-select':isSubGroupOdd==selectedSubGroup}" [disabled]="isFrozen">
            <!-- If want to disable this field please use the flag freezeSubGroupDropDown -->
            <input type="search" id="SubGroupSearch" class="dropdownsearchstyle" [(ngModel)]="SubGroupTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of subGroupDropDown| assessmentSearch :SubGroupTxt" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <input class="input-filed-continers" *ngIf="showSubGroupAsTextBox" type="text"
            [(ngModel)]="auData.subGroupName">
        </div>

        <div class="col-md-3">
          <div>
            <label id="lead-auditor-validation" for="email">{{dynamicLabel['LEAD_AUDITOR_USER'].fieldName}}</label>
            <span *ngIf="selectedTab == 'Audit Plan'" class="mandatory-symbol">*</span>
            <label *ngIf="getSwitchUserPrivilege() && !isFrozen" id="owner-validation" for="email"><a
                (click)="openswitchuser('LeadAuditor')"><img title="Switch User"
                  src="..//..//../assets/img/user-switch.png" alt="Switch User Img" width="23" height="23"></a></label>
            <span class="info-icon" *ngIf="dynamicLabel['LEAD_AUDITOR_USER']?.fieldNotes"
              [matTooltip]="dynamicLabel['LEAD_AUDITOR_USER']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedLeadAuditor" (closed)="leadAuditorTxt=''"
            (click)="focusSearch('leadAuditorSearch')" (keydown.enter)="focusSearch('leadAuditorSearch')"
            [ngClass]="{'odd-item-mat-select':isLeadAuditorOdd==selectedLeadAuditor}" [disabled]="isFrozen">
            <input type="search" id="leadAuditorSearch" class="dropdownsearchstyle" [(ngModel)]="leadAuditorTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onLeadAuditorSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of leadAuditorDropDown| assessmentSearch :leadAuditorTxt"
              (onSelectionChange)="onLeadAuditorSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="auData.scheduledByUser">
          <div>
            <label for="email"> {{dynamicLabel['SCHEDULED_BY_USER'].fieldName}} </label>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="auData.scheduledByUser" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="auData.scheduleApprovalRequestedOn && selectedTab=='Annual Audit Schedule'">
          <div>
            <label for="email"> {{dynamicLabel['SCHEDULE_APPROVAL_REQUESTED_ON'].fieldName}} </label>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.scheduleApprovalRequestedOn" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="auData.scheduleApprovedOn && selectedTab=='Annual Audit Schedule'">
          <div>
            <label for="email"> {{dynamicLabel['SCHEDULE_APPROVED_ON'].fieldName}} </label>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.scheduleApprovedOn" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="auData.scheduleRejectedOn && selectedTab=='Annual Audit Schedule'">
          <div>
            <label for="email">{{dynamicLabel['SCHEDULE_REJECTED_ON'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['SCHEDULE_REJECTED_ON']?.fieldNotes"
              [matTooltip]="dynamicLabel['SCHEDULE_REJECTED_ON']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.scheduleRejectedOn" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="selectedTab=='Annual Audit Schedule'">
          <div>
            <label id="schedule-approver-validation"
              for="email">{{dynamicLabel['SCHEDULE_APPROVED_BY_USER'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <label *ngIf="getSwitchUserPrivilege()" for="email"><a (click)="openswitchuser('ScheduleApprover')"
                (keydown.enter)="openswitchuser('ScheduleApprover')"><img title="Switch User"
                  src="..//..//../assets/img/user-switch.png" alt="Switch User Img" width="23" height="23"></a></label>
            <span class="info-icon" *ngIf="dynamicLabel['SCHEDULE_APPROVED_BY_USER']?.fieldNotes"
              [matTooltip]="dynamicLabel['SCHEDULE_APPROVED_BY_USER']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedScheduleApprover"
            (closed)="scheduleApproverTxt=''" (click)="focusSearch('leadAuditorSearch')"
            (keydown.enter)="focusSearch('leadAuditorSearch')"
            [ngClass]="{'odd-item-mat-select':isScheduleApproverOdd==selectedScheduleApprover}" [disabled]="isFrozen">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="scheduleApproverTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of scheduleApproverDropDown| assessmentSearch :scheduleApproverTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="auData.scheduleApproverComments && selectedTab=='Annual Audit Schedule'">
          <div>
            <label for="email"> {{dynamicLabel['SCHEDULE_APPROVER_COMMENTS'].fieldName}} </label>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="auData.scheduleApproverComments" [disabled]="true"></textarea>
        </div>

        <div class="col-md-3" *ngIf="auData.plannedByUser && selectedTab == 'Audit Plan'">
          <div>
            <label for="email"> {{dynamicLabel['PLANNED_BY_USER'].fieldName}} </label>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="auData.plannedByUser" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="auData.planApprovalRequestedOn && selectedTab == 'Audit Plan'">
          <div>
            <label for="email"> {{dynamicLabel['PLAN_APPROVAL_REQUESTED_ON'].fieldName}} </label>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.planApprovalRequestedOn" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="auData.planApprovedOn && selectedTab == 'Audit Plan'">
          <div>
            <label for="email"> {{dynamicLabel['PLAN_APPROVED_ON'].fieldName}} </label>
          </div>

          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.planApprovedOn" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="selectedTab != 'Annual Audit Schedule' && auData.planRejectedOn">
          <div>
            <label for="email">{{dynamicLabel['PLAN_REJECTED_ON'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['PLAN_REJECTED_ON']?.fieldNotes"
              [matTooltip]="dynamicLabel['PLAN_REJECTED_ON']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.planRejectedOn" [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="selectedTab == 'Audit Plan'">
          <div>
            <label id="plan-approver-validation" for="email">{{dynamicLabel['PLAN_APPROVED_BY_USER'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <label *ngIf="getSwitchUserPrivilege() && !isFrozen" for="email"><a
                (click)="openswitchuser('PlanApprover')"><img title="Switch User"
                  src="..//..//../assets/img/user-switch.png" alt="Switch User Img" width="23" height="23"></a></label>
            <span class="info-icon" *ngIf="dynamicLabel['PLAN_APPROVED_BY_USER']?.fieldNotes"
              [matTooltip]="dynamicLabel['PLAN_APPROVED_BY_USER']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedPlanApprover" (closed)="planApproverTxt=''"
            (click)="focusSearch('planApproverTxtSearch')" [disabled]="isFrozen"
            (keydown.enter)="focusSearch('planApproverTxtSearch')"
            [ngClass]="{'odd-item-mat-select':isPlanApproverOdd==selectedPlanApprover}">
            <input type="search" id="planApproverTxtSearch" class="dropdownsearchstyle" [(ngModel)]="planApproverTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onPlanApproverSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of planApproverDropDown| assessmentSearch :planApproverTxt"
              (onSelectionChange)="onPlanApproverSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="auData.planApproverComments && selectedTab == 'Audit Plan'">
          <div>
            <label for="email"> {{dynamicLabel['PLAN_APPROVER_COMMENTS'].fieldName}} </label>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="auData.planApproverComments" [disabled]="true"></textarea>
        </div>

        <div class="col-md-3" *ngIf="selectedTab == 'Audit Plan'">
          <div>
            <label id="participant-validation" for="email">{{dynamicLabel['PRIMARY_AUDITEE'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="participantData.participantName"
                (ngModelChange)="onNgModelChange($event,'participant-validation')" [disabled]="true">
            </div>
            <div class="col-sm-1"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
              [hidden]="auData.status=='Scheduled'" (click)="openParticipantPopup()"
              (keydown.enter)="openParticipantPopup()" [ngClass]="{'disabled': isFrozen}">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3" *ngIf="selectedTab == 'Audit Plan' && this.operationFlag == 'EDIT'">
          <div>
            <label for="email">{{dynamicLabel['QUESTION_AND_ANSWER_SECTION_TYPE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['QUESTION_AND_ANSWER_SECTION_TYPE']?.fieldNotes"
              [matTooltip]="dynamicLabel['QUESTION_AND_ANSWER_SECTION_TYPE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auData.questionAndAnswerSectionType" [disabled]="isFrozen">
            <span class="active-inActive-container" *ngIf="auData.questionAndAnswerSectionType==true"
              [ngStyle]="auData.questionAndAnswerSectionType==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
            <span *ngIf="auData.questionAndAnswerSectionType==false"
              [ngStyle]="auData.questionAndAnswerSectionType==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3"
          *ngIf="selectedTab == 'Annual Audit Schedule' && dynamicLabel['MULTIPLE_PLANS']?.isRemovable != 'Y'">
          <div>
            <label for="email">{{dynamicLabel['MULTIPLE_PLANS'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['MULTIPLE_PLANS']?.fieldNotes"
              [matTooltip]="dynamicLabel['MULTIPLE_PLANS']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auData.multiplePlans" [disabled]="isFrozen">
            <span class="active-inActive-container" *ngIf="auData.multiplePlans==true"
              [ngStyle]="auData.multiplePlans==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
            <span *ngIf="auData.multiplePlans==false"
              [ngStyle]="auData.multiplePlans==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3">
          <div>
            <label id="expected-start-validation" for="email">
              {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']==undefined?
              'Expected To be Started On':dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [disabled]="isFrozen"
            [bsConfig]="expectedToBeStartedOnDateConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="auData.expectedToBeStartedOn" (ngModelChange)="handleExpectedStartChange($event)">
        </div>

        <div class="col-md-3">
          <div>
            <label id="expected-closure-validation" for="email">
              {{dynamicLabel['EXPCETED_CLOSURE_ON']==undefined?
              'Expected Closure On':dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
              [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [disabled]="isFrozen"
            [bsConfig]="expectedClosureOnDateConfig()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="auData.expcetedClosureOn"
            (ngModelChange)="onNgModelChange($event, 'expected-closure-validation')">
        </div>

        <div class="col-md-3" *ngIf="this.selectedTab == 'Annual Audit Schedule'">
          <div>
            <label for="email">{{dynamicLabel['INTIMATE_TO_PLAN_N_DAYS_BEFORE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['INTIMATE_TO_PLAN_N_DAYS_BEFORE']?.fieldNotes"
              [matTooltip]="dynamicLabel['INTIMATE_TO_PLAN_N_DAYS_BEFORE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input class="input-filed-continers" type="number" [(ngModel)]="auData.intimateToPlanNDaysBefore" min="1"
            (keypress)="numberValidation($event)" [disabled]="isFrozen">
        </div>

        <div class="col-md-6" *ngIf="this.selectedTab == 'Annual Audit Schedule'">
          <div>
            <label for="email">
              {{dynamicLabel['PLAN_INTIMATION_EMAIL_USERS_BY_NAME']==undefined ?
              'Plan Intimate User(s)':
              dynamicLabel['PLAN_INTIMATION_EMAIL_USERS_BY_NAME'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['PLAN_INTIMATION_EMAIL_USERS_BY_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['PLAN_INTIMATION_EMAIL_USERS_BY_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row g-0">
            <div class="col-md-5 users-container">
              <div class="file-list">
                <span class="user-name" *ngFor="let user of selectedPlanUsers; let i = index">
                  {{user.userName}}&nbsp;&nbsp;
                  <button class="remove-file-button" (click)="onUserRemoved(i)"
                    matTooltip="Remove User">✕</button></span>
              </div>
            </div>
            <div class="col-md-1 search-icon-div">
              <div class="search-user" style="font-size: 1.3em" matTooltip="Search User(s)"
                (click)="opensSearchUsersPopup('Plan')" (keydown.enter)="opensSearchUsersPopup('Plan')">
                <i class="fa fa-search"></i>
              </div>
              <div *ngIf="selectedPlanUsers.length > 1" matTooltip="Remove All User(s)" class="search-user"
                style="font-size: 1.3em" (click)="removeAllUsers()" (keydown.enter)="removeAllUsers()">
                <i class="fa fa-trash"></i>
              </div>
            </div>
          </div>
        </div>



        <div class="col-md-3" *ngIf="this.selectedTab == 'Audit Plan'">
          <div>
            <label id="start-date" for="email">{{dynamicLabel['START_DATE'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['START_DATE']?.fieldNotes"
              [matTooltip]="dynamicLabel['START_DATE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker
            [disabled]="this.selectedTab != 'Audit Plan'" [bsConfig]="startDateConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.startDate" (ngModelChange)="onStartDateChange()"
            [disabled]="isFrozen">
        </div>

        <div class="col-md-3" *ngIf="this.selectedTab == 'Audit Plan'">
          <div>
            <label id="end-date" for="email">{{dynamicLabel['END_DATE'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['END_DATE']?.fieldNotes"
              [matTooltip]="dynamicLabel['END_DATE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>

          <input type=" text" class="form-control data-picker-continer" bsDatepicker
            [disabled]="this.selectedTab != 'Audit Plan'" [bsConfig]="auEndDateConfig()"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auData.endDate" [disabled]="isFrozen">
        </div>
        <div class="col-md-3" *ngIf="this.selectedTab == 'Audit Plan'">
          <div>
            <label for="email">{{dynamicLabel['INTIMATE_TO_CONDUCT_N_DAYS_BEFORE']==undefined?
              'Intimate To Conduct N Days Before':
              dynamicLabel['INTIMATE_TO_CONDUCT_N_DAYS_BEFORE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['INTIMATE_TO_CONDUCT_N_DAYS_BEFORE']?.fieldNotes"
              [matTooltip]="dynamicLabel['INTIMATE_TO_CONDUCT_N_DAYS_BEFORE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input class="input-filed-continers" type="number" [(ngModel)]="auData.intimateToConductNDaysBefore"
            [disabled]="isFrozen" min="1" (keypress)="numberValidation($event)">
        </div>
        <div class="col-md-6" *ngIf="this.selectedTab == 'Audit Plan'">
          <div>
            <label for="email">{{dynamicLabel['CONDUCT_INTIMATION_EMAIL_USERS_NAMES'].fieldName}}</label>
          </div>

          <!-- Row wrapper added here -->
          <div class="row g-0">
            <div class="col-md-5 users-container">
              <div class="file-list">
                <span class="user-name" *ngFor="let user of selectedConductUsers; let i = index">
                  {{user.userName}}&nbsp;&nbsp;
                  <button class="remove-file-button" (click)="onUserRemoved(i)" matTooltip="Remove User">✕</button>
                </span>
              </div>
            </div>

            <div class="col-md-1 search-icon-div">
              <div class="search-user" style="font-size: 1.3em" matTooltip="Search User(s)"
                (click)="opensSearchUsersPopup('Conduct')" (keydown.enter)="opensSearchUsersPopup('Conduct')"
                [ngClass]="{'disabled': isFrozen}">
                <i class="fa fa-search"></i>
              </div>
              <div *ngIf="selectedConductUsers.length > 1" matTooltip="Remove All User(s)" class="search-user"
                style="font-size: 1.3em" (click)="removeAllUsers()" (keydown.enter)="removeAllUsers()">
                <i class="fa fa-trash"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <!-- Short Description -->
            <label for="short-description" id="short-description-validation">
              {{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input id="shortDescription" class="input-filed-continers" type="text"
            (input)="limitCharacters($event, 'SHORT_DESCRIPTION')" autocomplete="off"
            [(ngModel)]="auData.shortDescription"
            (ngModelChange)="onNgModelChange($event,'short-description-validation')" [disabled]="isFrozen">
        </div>


        <div class="col-md-6">
          <div>
            <label id="purpose-validation" for="email">{{dynamicLabel['AUDIT_PURPOSE']==undefined?
              'Audit Purpose':dynamicLabel['AUDIT_PURPOSE'].fieldName}}</label>
            <span class="mandatory-symbol" *ngIf="selectedTab == 'Audit Plan'">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_PURPOSE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_PURPOSE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auData.auditPurpose" [config]="config" [disabled]="isFrozen" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="isFrozen ? openEditor('Audit Purpose', 'eye') : openEditor('Audit Purpose', 'edit')"
              (keydown.enter)="isFrozen ? openEditor('Audit Purpose', 'eye') : openEditor('Audit Purpose', 'edit')">
              <i *ngIf="!isFrozen" class="far fa-edit"></i>
              <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <label id="scope-validation" for="email">{{dynamicLabel['AUDIT_SCOPE']==undefined?
              'Audit Scope':dynamicLabel['AUDIT_SCOPE'].fieldName}}</label>
            <span class="mandatory-symbol" *ngIf="selectedTab == 'Audit Plan'">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_SCOPE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_SCOPE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auData.auditScope" [config]="config" [disabled]="isFrozen" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="isFrozen ? openEditor('Audit Scope', 'eye') : openEditor('Audit Scope', 'edit')"
              (keydown.enter)="isFrozen ? openEditor('Audit Scope', 'eye') : openEditor('Audit Scope', 'edit')">
              <i *ngIf="!isFrozen" class="far fa-edit"></i>
              <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <label id="references-validation" for="email">{{dynamicLabel['AUDIT_REFERENCES']==undefined?
              'Audit References':dynamicLabel['AUDIT_REFERENCES'].fieldName}}</label>
            <span class="mandatory-symbol" *ngIf="selectedTab == 'Audit Plan'">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_REFERENCES']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_REFERENCES']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auData.auditReferences" [config]="config" [disabled]="isFrozen"
                [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="isFrozen ? openEditor('Audit References', 'eye') : openEditor('Audit References', 'edit')"
              (keydown.enter)="isFrozen ? openEditor('Audit References', 'eye') : openEditor('Audit References', 'edit')">
              <i *ngIf="!isFrozen" class="far fa-edit"></i>
              <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <label id="remarks-validation" for="email">
              {{dynamicLabel['REMARKS']==undefined?
              'Audit Remarks':dynamicLabel['REMARKS'].fieldName}}</label>
            <span class="mandatory-symbol" *ngIf="selectedTab == 'Audit Plan'">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['REMARKS']?.fieldNotes"
              [matTooltip]="dynamicLabel['REMARKS']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auData.remarks" [config]="config" [spellcheck]="true" [disabled]="isFrozen"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="isFrozen ? openEditor('Remarks', 'eye') : openEditor('Remarks', 'edit')"
              (keydown.enter)="isFrozen ? openEditor('Remarks', 'eye') : openEditor('Remarks', 'edit')">
              <i *ngIf="!isFrozen" class="far fa-edit"></i>
              <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3" *ngIf="qmsService.selectedGroupDetailData.isRiskCalculationReqd=='Y'">
          <div>
            <label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD']==undefined?
              'Is Risk Calculation Reqd?':dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
              [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auData.isRiskCalculationReqd" [disabled]="isFrozen">
            <span *ngIf="auData.isRiskCalculationReqd==true"
              [ngStyle]="auData.isRiskCalculationReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="auData.isRiskCalculationReqd==false"
              [ngStyle]="auData.isRiskCalculationReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3" *ngIf="qmsService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
          <div>
            <label for="email">
              {{dynamicLabel['EFFECTIVENESS_CHECK_REQD'] == undefined ?
              'Is Effectiveness Check Required?'
              : dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}
            </label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auData.effectivenessCheckReqd" [disabled]="isFrozen">
            <span class="active-inActive-container"
              [ngStyle]="{ color: auData.effectivenessCheckReqd ? 'green' : 'red' }">
              {{ auData.effectivenessCheckReqd ? 'Yes' : 'No' }}
            </span>
          </mat-slide-toggle>
        </div>
      </div>
      <br>
      <div
        *ngIf="auData.questionAndAnswerSectionType && this. qmsService.auditEditmodeDatas.usage=='DETAILS' && this.selectedTab != 'Annual Audit Schedule' && this.addplanStage==false">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="gridName">Questionnaire</span>
            </div>
          </div>
        </div>
        <app-au-questions [updateQuestionarie]="updateQuestionarie"
          *ngIf="this.selectedTab == 'Audit Plan' && showQuestions"></app-au-questions>
      </div><br>
      <div
        *ngIf="!visibleAddButton && (this.selectedTab == 'Audit Plan' || this.selectedTab == 'Annual Audit Schedule')">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="gridName">Documents</span>
            </div>
          </div>
        </div>
        <app-task-documents [activity]="this.objForDocuments"></app-task-documents>
      </div>
      <div class="ActivityPage" id="Additionaldetail" style="margin-top: 15px;" *ngIf="selectedTab == 'Audit Plan'">
        <app-flexible-fields #flexible [from]="this.visibleAddButton ? 'Master' : 'Details'"></app-flexible-fields>
      </div>
    </div>

  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions
    *ngIf="showAddEditbtn && this.addplanStage==false">
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addAndEditFunction()"
      (keydown.enter)="addAndEditFunction()" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addAndEditFunction()"
      (keydown.enter)="addAndEditFunction()" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color:white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions *ngIf="this.addplanStage">
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addAndEditFunction()"
      (keydown.enter)="addAndEditFunction()" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Create New Plan</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label id="delete-reason-validation" for="email">Reason for Delete</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="auData.deleteReason"
            (ngModelChange)="onNgModelChange(auData.deleteReason, 'delete-reason-validation')"></textarea>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction(auData)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? config1 : config" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #vendorPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelVendorPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Vendor </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>

  <div [ngStyle]="vendorList.length==0?{'height':'350px'} : {'':''}">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Vendor Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByVendorName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Vendor Code</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByVendorCode">
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchVendorFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetVendorFunc()">
          <i class="fa fa-repeat"></i> Reset
        </button>
        <button *ngIf="!showVendorGrid" mat-stroked-button class="cancelButton" (click)="cancelVendorPopup()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>

  <div class="form-continer">
    <div class="no-result-found" *ngIf="noResultFound">
      No Result Found
    </div>
    <div class="table-container" *ngIf="showVendorGrid">
      <table class="search-manager-table-container" aria-describedby="table-description" style="height: 50vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
            </div>
          </th>
          <th>
            <span>Vendor Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Vendor Code</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Services Offered Code</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Services Offered Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Year Established</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Email Address</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let vendor of vendorList; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="vendor.vendorChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="vendor.vendorChildCheckBoxs"
                    (change)="vendorGridCheckBox($event, vendor, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ vendor.vendorName }}</td>
            <td class="row-data">{{ vendor.vendorCode }}</td>
            <td class="row-data">{{ vendor.servicesOffered }}</td>
            <td class="row-data">{{ vendor.servicesOfferedNames }}</td>
            <td class="row-data">{{ vendor.yearEstablished }}</td>
            <td class="row-data">{{ vendor.emailAddress }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showVendorGrid">
    <button mat-stroked-button class="addButton" (click)="selectVendor()">
      <i class="fas fa-check"></i> Add
    </button>
    <button *ngIf="showVendorGrid" mat-stroked-button class="cancelButton" (click)="cancelVendorPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #departmentPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelDepartmentPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Department </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Code List Name(Department Name)</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByCodeListName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Code List Code(Department Code)</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByCodeListCode">
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchDepartmentFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelDepartmentPopup()"
          *ngIf="!departmentList.length">
          <i class="fa fa-close"></i> Cancel
        </button>
        <button mat-stroked-button class="cancelButton"
          *ngIf="searchByCodeListName || searchByCodeListCode || departmentList.length" (click)="resetDepartmentFunc()">
          <i class="fas fa-undo"></i> Reset
        </button>
      </div>
    </div>

    <div class="no-result-found" *ngIf="noResultFound">
      No Result Found
    </div>

    <div class="table-container" *ngIf="departmentList.length">
      <table class="search-manager-table-container" aria-describedby="table-description" style="max-height: 40vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
            </div>
          </th>
          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Code List Group Name</span>
            </div>
          </th>
          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Code List Code</span>
            </div>
          </th>
          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Code List Name</span>
            </div>
          </th>
          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Sub Group Name</span>
            </div>
          </th>
          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Sub Group Values</span>
            </div>
          </th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let department of departmentList; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="department.departmentChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input type="checkbox" style="zoom: 1.2;" [checked]="department.departmentChildCheckBox"
                    (change)="departmentGridCheckBox($event, department, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ department.codelistsPk.groupName }}</td>
            <td class="row-data">{{ department.codelistsPk.codelistCode }}</td>
            <td class="row-data">{{ department.codelistName }}</td>
            <td class="row-data">{{ department.subgroupName }}</td>
            <td class="row-data">{{ department.subgroupValues }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="departmentList.length">
    <button mat-stroked-button class="addButton" (click)="selectDepartment()" [disabled]="!getCheckedDepartmentCode">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelDepartmentPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #participantPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelParticipantSelect()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Participant </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 5px;">
    <div class="row">
      <div class="col-md-3" *ngIf="!isPrimaryAuditee">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div class="field-icon-container"></div>
      </div>
      <div class="col-md-3" *ngIf="!isPrimaryAuditee">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div class="field-icon-container"></div>
      </div>
      <div class="col-md-3" *ngIf="!isPrimaryAuditee">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div class="field-icon-container"></div>
      </div>
      <div class="col-md-3" *ngIf="!isPrimaryAuditee">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByEmailAddress">
      </div>
      <div class="col-md-3" *ngIf="!isPrimaryAuditee">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode" (closed)="designationCodeTxt=''"
          (click)="focusSearch('designationCodeSearch')" (keydown.enter)="focusSearch('designationCodeSearch')">
          <input type="search" id="designationCodeSearch" class="dropdownsearchstyle" [(ngModel)]="designationCodeTxt"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of designationListDropdown| assessmentSearch :designationCodeTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="!isPrimaryAuditee">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentCodeSearchTxt=''" (click)="focusSearch('departmentCodeSearch')"
          (keydown.enter)="focusSearch('departmentCodeSearch')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentCodeSearchTxt" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentListDropdown| assessmentSearch :departmentCodeSearchTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>

      </div>
      <div class="col-md-2">
        <div><label for="email">Is Primary Auditee</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="isPrimaryAuditee" (change)="toggle($event)">
          <ng-container *ngIf="isPrimaryAuditee; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row" *ngIf="!isPrimaryAuditee">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchParticipant()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetParticipant()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isPrimaryAuditee && participantListForGrid.length > 0">
    <div class="table-container">
      <table style="max-height: 48vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>First Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Last Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Full Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Designation</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Department</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Email</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Contact Number</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Manager Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Is Active?</span>
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let participant of participantListForGrid; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="participant.participantChildCheckBox ? 'static_icon' : 'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input type="checkbox" style="zoom: 1.2;" [checked]="participant.participantChildCheckBox"
                    (change)="participantChildCheckBoxChecked($event, participant, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ participant.userName }}</td>
            <td class="row-data">{{ participant.firstName }}</td>
            <td class="row-data">{{ participant.lastName }}</td>
            <td class="row-data">{{ participant.userFullName }}</td>
            <td class="row-data">{{ participant.designation }}</td>
            <td class="row-data">{{ participant.department }}</td>
            <td class="row-data">{{ participant.emailAddress }}</td>
            <td class="row-data">{{ participant.contactNumber }}</td>
            <td class="row-data">{{ participant.managerName }}</td>
            <td class="row-data" style="text-align: center; zoom: 1.2;">
              <div class="gridCheckBoxes">
                <img *ngIf="participant.isActive" src=" ../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                  height="20">
                <img *ngIf="!participant.isActive" src=" ../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                  height="20">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="isPrimaryAuditee">
    <div class="table-container">
      <table class="search-participant-table-container" aria-describedby="table-description" style="max-height: 51vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>First Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Last Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Full Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Designation</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Department</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '200px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Email Address</span>
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>
        <div *ngIf="isPrimaryAuditee">
          <tbody>
            <tr class="data-row-container" *ngFor="let participant of primaryAuditeeList; let idx = index;"
              [class.highlightRow]="participant.participantChildCheckBox">
              <td style="min-width: 60px; text-align: center;">
                <div style="display: flex;">
                  <div [ngClass]="participant.participantChildCheckBox ? 'static_icon' : 'hover-menu-icons'">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px;">
                    <input type="checkbox" style="zoom: 1.2;" [checked]="participant.participantChildCheckBox"
                      (change)="participantChildCheckBoxChecked($event, participant, idx)">
                  </div>
                </div>
              </td>
              <td class="row-data">{{ participant.userName }}</td>
              <td class="row-data">{{ participant.firstName }}</td>
              <td class="row-data">{{ participant.lastName }}</td>
              <td class="row-data">{{ participant.userFullName }}</td>
              <td class="row-data">{{ participant.designation }}</td>
              <td class="row-data">{{ participant.department }}</td>
              <td class="row-data">{{ participant.emailAddress }}</td>
            </tr>
          </tbody>
        </div>
      </table>
    </div>
  </div>

  <div class="button-continer btn-align" mat-dialog-actions *ngIf="(displayParticipantGrid && participantListForGrid.length > 0) ||
       (isPrimaryAuditee && primaryAuditeeList.length > 0)">
    <button mat-stroked-button class="addButton" (click)="selectParticipant()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelParticipantSelect()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>

  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;">
        <span *ngIf="!getFailedConditionMet()">
          Please enter all Mandatory Fields
        </span>
        <span *ngIf="getFailedConditionMet()">
          Please add Questionnaire
        </span>
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #auditeeAlertPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>

  <button class="close close-button" (click)="closeAuditeeAlertPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Lead Auditor and Auditee cannot be the same user
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeAuditeeAlertPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #searchUsersPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelSearchUsersPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search User(s) </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 20px;">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName">
        <div class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName">
        <div class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="searchByLastName">
        <div class="field-icon-container"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Email</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Email" [(ngModel)]="searchByEmail">
        <div id="email-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode" (closed)="designationCodeTxt=''"
          (click)="focusSearch('designationCode1Search')" (keydown.enter)="focusSearch('designationCode1Search')">
          <input type="search" id="designationCode1Search" class="dropdownsearchstyle" [(ngModel)]="designationCodeTxt"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of designationListDropdown| assessmentSearch :designationCodeTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentCodeSearchTxt=''" (click)="focusSearch('departmentCodeSearch')"
          (keydown.enter)="focusSearch('departmentCodeSearch')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentCodeSearchTxt" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentListDropdown| assessmentSearch :departmentCodeSearchTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row" style="margin-top: 4%;">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUsersFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUsers()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="static-table-container" aria-describedby="table-description" style="height: 50vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="searchUserParentCheckBox"
                  (change)="onParentCheckBoxChanged($event)">
              </div>
            </div>
          </th>
          <th>
            <span>User Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>First Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Last Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Designation</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Department</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>EmailAddress</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Is Ad User</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let user of qmsUsersList; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="user.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input type="checkbox" style="zoom: 1.2;" [checked]="user.searchUserChildCheckBox"
                    (change)="onChildCheckBoxChanged($event, user, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ user.userName }}</td>
            <td class="row-data">{{ user.firstName }}</td>
            <td class="row-data">{{ user.lastName }}</td>
            <td class="row-data">{{ user.designation }}</td>
            <td class="row-data">{{ user.department }}</td>
            <td class="row-data">{{ user.emailAddress }}</td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="user.isAdUser">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="getUsers()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUsersPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!-- PDF Report Popup-->
<ng-template #openExportReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Choose Report Template </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer1">
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="reportTemplate-validation" for="email">Report Template</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">


        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplateValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onPdfDetailValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportTemplateDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onPdfDetailValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="exportReportGenerateFuntion()">
      <i class="fas fa-check"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="exportReportCancelPopupFuntion()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-top-navigation [hidden]="true"></app-top-navigation>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-editor #clobViewPopup></app-editor>
<ng-template #viwerClobPopup>
  <button style="background: #005C8A;margin-right: 1%;" class="close close-button" (click)="closeHtmlContent()"
    mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div class="col-sm-12">
    <st-editor [(ngModel)]="htmlContent" [config]="config1" (paste)="onPaste($event)" [spellcheck]="true"
      [disabled]="true" (paste)="onPaste($event)"></st-editor>
  </div>
</ng-template>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmittedMethod()"></app-grid-reorder>
<app-activity-au-trail></app-activity-au-trail>
